import TabPanelVariant from './tab-panel-variant'

export default TabPanelVariant
